module.exports = __webpack_public_path__ + "img/vk-footer.b75db46f.svg";